export default "/assets/images/dusty-taupe-sm.jpg?3baae2c7f064004918f9916fb1ac64db";